import { render, staticRenderFns } from "./TestModal.vue?vue&type=template&id=f97483a6&"
import script from "./TestModal.vue?vue&type=script&lang=js&"
export * from "./TestModal.vue?vue&type=script&lang=js&"
import style0 from "./TestModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports